const Settings = {
    urls: {
        SettingsUrl: window.SETTINGS_API_URL || '/id/api/v2/settings/',
        AccountStateUrl: window.ACCOUNT_STATE_URL || '/id/state.json',
        BaseIDUrl: '/id/'
    },
    SYNC_TIMEOUT: 500,
    LEAD_SYNC: false,
    SUBMIT_THROTTLE: 100
};

export default Settings;



// WEBPACK FOOTER //
// ./static-source/default_settings.js